module.exports = __webpack_public_path__ + "static/img/BV.b4b3ddb3.svg";